<button
  class="va-button va-button-outline va-button-outline--primary"
  [ngClass]="[
    isVisibleEteModal ? 'va-button--active' : '',
    disabled ? 'va-button--disabled' : ''
  ]"
  (click)="onGlobalSettingsBtnClick()"
  title="Global Settings"
>
  <va-icon
    size="small"
    name="cog"
    [class]="[showText ? 'mr-8' : 'aligning-icon']"
  ></va-icon>
  <span *ngIf="showText">Global Settings </span>
</button>
